import React from 'react';

const Footer = () => {
    return (
        <footer className="bg-dark-blue text-white py-8">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                <p className="text-lg mb-2">
                    <span className="text-safety-yellow font-bold">InterPak</span> Oil Fields Services
                </p>
                <p className="text-off-white/80">A House of Quality Services & Satisfaction</p>
                <p className="text-off-white/60 mt-4 text-sm">© 2025 InterPak. All rights reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;
